import React from "react";
import { NavLink } from "react-router-dom";
import { Nav, Collapse } from "reactstrap";
// react plugin for creating notifications over the dashboard
import NotificationAlert from "react-notification-alert";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";

import { Button } from "components";

import avatar from "assets/img/avatar-placeholder.png";
import logo from "assets/img/logo-minosx.png";
import xperienceBrand from "assets/img/xperience-brand-125.png";
import { permissions } from '../../helpers';
import User from '../../entities/User';
import { withTranslation } from 'react-i18next';

var ps;

class Sidebar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      //openAvatar: false,
      //openComponents: this.activeRoute("/components") !== "" ? true : false,
      //openForms: this.activeRoute("/forms") !== "" ? true : false,
      //openTables: this.activeRoute("/tables") !== "" ? true : false,
      //openMaps: this.activeRoute("/maps") !== "" ? true : false,
      openPages: this.activeRoute("/pages") !== "" ? true : false,
      //openSettings: this.activeRoute("/settings") !== "" ? true : false,
    };
    this.activeRoute.bind(this);
    this.minimizeSidebar = this.minimizeSidebar.bind(this);
  }
  // verifies if routeName is the one active (in browser input)
  activeRoute(routeName) {
    return this.props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
  }
  minimizeSidebar() {
    document.body.classList.toggle("sidebar-mini");
    // Notification alert (Sidebar mini)
    // var options = {};
    // options = {
    //   place: "tr",
    //   message: 'Sidebar mini',
    //   type: "info",
    //   icon: "now-ui-icons ui-1_bell-53",
    //   autoDismiss: 7
    // };
    //this.refs.notificationAlert.notificationAlert(options);
  }
  componentDidMount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(this.refs.sidebar, {
        suppressScrollX: true,
        suppressScrollY: false
      });
    }
  }
  componentWillUnmount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps.destroy();
    }
  }
  render() {

    const { t } = this.props;

    let user = User.current();

    return (
      <div>
        <NotificationAlert ref="notificationAlert" />
        <div className="sidebar" data-color="blue">

          <div className="logo">
            <a
              href="https://www.umpi.it/"
              target="_blank"
              className="simple-text logo-mini"
            >
              <div className="logo-img">
                <img src={logo} alt="minosx-logo" />
              </div>
            </a>
            <a
              href="/dashboard"
              className="simple-text logo-normal"
            >
              <img src={xperienceBrand} />
            </a>
            <div className="navbar-minimize">
              <Button
                simple
                neutral
                icon
                round
                id="minimizeSidebar"
                onClick={this.minimizeSidebar}
              >
                <i className="now-ui-icons text_align-center visible-on-sidebar-regular" />
                <i className="now-ui-icons design_bullet-list-67 visible-on-sidebar-mini" />
              </Button>
            </div>
          </div>

          <div className="sidebar-wrapper" ref="sidebar">
            <div className="user">
              <div className="photo">
                <img src={avatar} alt="Avatar" />
              </div>
              <div className="info">
                <a
                  data-toggle="collapse"
                  aria-expanded={this.state.openAvatar}
                  onClick={() =>
                    this.setState({ openAvatar: !this.state.openAvatar })
                  }
                >
                  <span>
                    {user.name + ' ' + user.surname}
                    <b className="caret" />
                  </span>
                </a>
                <Collapse isOpen={this.state.openAvatar}>
                  <Nav>
                        <li
                          className=""
                          key="profile"
                        >
                          <NavLink
                            className="nav-link custom-nav-link"
                            to={"/users/profile/"+user.id}
                            activeClassName="active"
                          >
                          <span className="sidebar-mini-icon">
                            P
                          </span>
                          <span className="sidebar-normal">
                            {t("Profilo")}
                          </span>
                          </NavLink>
                        </li>
                    
                      <li
                        className=""
                        key="logout"
                      >
                        <NavLink
                          className="nav-link custom-nav-link"
                          to={"/pages/login-page"}
                          activeClassName="active"
                        >
                          <i className="now-ui-icons arrows-1_share-66" />
                          <p>{t("Esci")}</p>
                        </NavLink>
                      </li>
                  </Nav>
                </Collapse>
              </div>
            </div>

            <Nav>
              {this.props.routes.map((prop, key) => {

                if (prop.invisible) {
                  return null;
                }

                if (prop.permission && !permissions.grant(prop.permission)) {
                  return null;
                }

                if (prop.redirect) return null;
                if (prop.collapse) {
                  var st = {};
                  st[prop["state"]] = !this.state[prop.state];
                  return (
                    <li className={this.activeRoute(prop.path)} key={key}>
                      <a
                        data-toggle="collapse"
                        aria-expanded={this.state[prop.state]}
                        onClick={() => this.setState(st)}
                      >
                        <i className={"now-ui-icons " + prop.icon} />
                        <p>
                          {t(prop.name)}
                          <b className="caret" />
                        </p>
                      </a>
                      <Collapse isOpen={this.state[prop.state]}>
                        <ul className="nav">
                          {prop.views.map((prop, key) => {
                            if (prop.redirect)
                              return null;
                            if (prop.invisible) {
                              return null;
                            }
                            if (prop.permission && !permissions.grant(prop.permission)) {
                              return null;
                            }

                            return (
                              <li
                                className={this.activeRoute(prop.path)}
                                key={key}
                              >
                                <NavLink
                                  to={prop.path}
                                  activeClassName="active"
                                >
                                  <span className="sidebar-mini-icon">
                                    {prop.mini}
                                  </span>
                                  <span className="sidebar-normal">
                                    {t(prop.name)}
                                  </span>
                                </NavLink>
                              </li>
                            );
                          })}
                        </ul>
                      </Collapse>
                    </li>
                  );
                }
                return (
                  <li className={this.activeRoute(prop.path)} key={key}>
                    <NavLink
                      to={prop.path}
                      className="nav-link"
                      activeClassName="active"
                    >
                      <i className={"now-ui-icons " + prop.icon} />
                      <p>{t(prop.name)}</p>
                    </NavLink>
                  </li>
                );
              })}
            </Nav>
          </div>
        </div>
      </div>
    );
  }
}

export default Sidebar = withTranslation()(Sidebar);



// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar.jsx